import React from 'react';
import clsx from 'clsx';
import { InputNumber } from '@components/framework/input/InputNumber';

interface CMRFieldBlockProps {
  indexLabel?: React.ReactNode;
  label?: React.ReactNode;
  sublabel?: React.ReactNode;
  value?: number;
  originalValue?: number;
  note?: string;
  editable?: boolean;
  borders?: boolean;
  onChange?: (val: number) => void;
}

const CMRTextFieldBlock: React.FC<CMRFieldBlockProps> = ({
                                                           indexLabel,
                                                           label,
                                                           sublabel,
                                                           value,
                                                           originalValue,
                                                           note,
                                                           editable = true,
                                                           borders = true,
                                                           onChange,
                                                         }) => {

  return (
    <div
      className={clsx(
        'flex flex-col w-full h-[135px] py-5 items-start gap-2',
        editable ? 'bg-base-base' : 'bg-white',
        borders ? 'px-2.5 border border-solid border-content-secondary' : '',
      )}>
      <div className="flex flex-row gap-1">
        <span
          className="text-[12px] font-dm-sans font-bold leading-normal tracking-[0.24px] text-[var(--Content-Primary,#343333)]">
          {indexLabel}
        </span>
        <span
          className="text-[12px] font-dm-sans font-bold leading-normal tracking-[0.24px] text-[var(--Content-Primary,#343333)]">
          {label}
        </span>
        <span
          className="text-[12px] font-dm-sans font-bold leading-normal tracking-[0.24px] text-[var(--Content-Tertiary,#B2B2B2)]">
          / {sublabel}
        </span>
      </div>
      {editable ? (
          <InputNumber
            className={clsx(
              'w-full h-[42px] border border-solid border-content-secondary hover:!border-content-brand hover:outline-none focus:!border-content-brand focus:outline-none',
            )}
            value={value}
            onChange={e => onChange(e.value)}
            mode="decimal"
            locale={'cs'}
            inputStyle={{ textAlign: 'right', border: 'none', boxShadow: 'none' }}
          />
        )
        : (
          <span className="text-[12px] font-dm-sans font-normal leading-[12px] text-content-brand">
              {note}
            </span>
        )}
      <span
        className="text-[12px] font-dm-sans font-bold leading-normal tracking-[0.24px] text-[var(--Content-Tertiary,#B2B2B2)]">
          {originalValue}
      </span>

    </div>
  );
};

export default CMRTextFieldBlock;